import React, {useState, useContext, useEffect} from 'react'
import AuthContext from '../../context/auth/AuthContext'
import PlaceContext from '../../context/place/PlaceContext'
import StoreContext from '../../context/store/StoreContext'
import UserContext from '../../context/user/UserContext'

import {toast} from '../ui/Toast'
import {SimpleContainer} from '../layout/Containers'
import {starterPlace, starterStores} from '../../utils/useStarterTemplate'
import {setAuthToken} from '../../utils/setAuthToken'
import { withComponentLabel } from '../../utils/debug'
  
const Register = (props) => {
  const authContext = useContext(AuthContext)
  const placeContext = useContext(PlaceContext)
  const storeContext = useContext(StoreContext)
  const userContext = useContext(UserContext)

  const {register} = authContext
  const {addPlace} = placeContext
  const {addStore, updateStore} = storeContext
  const {addUser, currentUser, token, error, clearUser, clearErrors} =
    userContext

  useEffect(() => {
    console.log('useEffect')
    console.log('currentUser per useEffect', currentUser)
    if (currentUser) {
      console.log('sending to verification-sent page')
      props.history.push('/verification-sent')
      clearUser()
    }
  }, [currentUser, props.history, clearUser])

  // sets state for form inputs
  const [user, setUser] = useState({
    name: '',
    email: '',
    password: '',
    password_conf: '',
    registration_key: '',
    pw_match: true,
  })

  const {name, email, password, password_conf} = user

  let pw_check = true // TODO add as state?  add as a default parameter to onPasswordConfChange?

  const onChange = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    })
  }

  // on change handler for password matching
  const onPasswordConfChange = (e) => {
    e.target.value === user.password ? (pw_check = true) : (pw_check = false)
    setUser({
      ...user,
      password_conf: e.target.value,
      pw_match: pw_check,
    })
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    clearErrors()
    // checks state values for password matching
    if (password !== password_conf) {
      toast.error("Passwords don't match!")
    } else {
      // if password matches, register user
      try {
        await addUser({
          name,
          email,
          password,
        })
      } catch (err) {
        console.log(err, 'this is the error')
      }
    }
  }

  return (
    <SimpleContainer>
      <div className='text-center text-3xl font-bold'>
        Sign up for <div className='text-orange-400'>Grocerylist.me</div>
      </div>
      <div className='flex flex-col items-center justify-center w-full mt-10'>
        <form onSubmit={onSubmit} className='w-full md:w-2/3'>
          <div className='mb-6'>
            <label htmlFor='name' className='block leading-8 text-slate-800'>
              Name
            </label>
            <input
              type='text'
              name='name'
              id='name'
              value={name}
              onChange={onChange}
              className='w-full rounded-md p-1 bg-slate-100 ring-4 ring-orange-300 transition-all focus:outline-none focus:ring-orange-400 focus:bg-slate-50 focus:border-orange-500'
              required
            />
          </div>
          <div className='mb-6'>
            <label htmlFor='email' className='block leading-8 text-slate-800'>
              Email
            </label>{' '}
            <input
              type='text'
              name='email'
              id='email'
              value={email}
              onChange={onChange}
              className='validate w-full rounded-md p-1 bg-slate-100 ring-4 ring-orange-300 transition-all focus:outline-none focus:ring-orange-400 focus:bg-slate-50 focus:border-orange-500'
              required
            />
          </div>
          <div className='mb-6'>
            <label
              htmlFor='password'
              className='block leading-8 text-slate-800'
            >
              Password
            </label>
            <input
              type='password'
              name='password'
              id='password'
              value={password}
              onChange={onChange}
              className='validate w-full rounded-md p-1 bg-slate-100 ring-4 ring-orange-300 transition-all focus:outline-none focus:ring-orange-400 focus:bg-slate-50 focus:border-orange-500'
              required
              minLength='6'
            />
          </div>
          <div className='mb-6'>
            <label
              htmlFor='password_conf'
              className='block leading-8 text-slate-800'
            >
              Confirm password
            </label>
            <input
              id='password_conf'
              type='password'
              name='password_conf'
              value={password_conf}
              onChange={onPasswordConfChange}
              className={`w-full rounded-md p-1 bg-slate-100 ring-4 focus:outline-none transition-all focus:bg-slate-50  ${
                user.pw_match
                  ? 'ring-orange-300 focus:ring-orange-400'
                  : 'ring-red-500 focus:ring-red-500'
              }`}
              required
              minLength='6'
            />
          </div>
          {error && (
            <div className='flex justify-center -mb-10'>
              {console.log('error in render', error)}
              <div className='w-full md:w-1/2 bg-red-400 mb-3 p-3 rounded-xl border-2 border-red-500 text-gray-50'>
                <span className='text-center font-bold leading-relaxed block'>
                  Error!
                </span>
                {error.response?.status === // validation error in submitted form
                  400 && (
                  <ul>
                    {error.response.data.errors.map((error, i) => (
                      <li key={i} className='text-center'>
                        {error.msg}
                      </li>
                    ))}
                  </ul>
                )}
                {error.response?.status === // user already exists
                  403 && <div>{error.response.data.msg}</div>}
              </div>
            </div>
          )}
          <div className='flex justify-center my-10'>
            <button
              type='submit'
              name='action'
              className='w-full md:w-2/3 bg-emerald-500 rounded-full p-5 text-white font-extrabold'
            >
              Register
            </button>
          </div>
        </form>
      </div>
    </SimpleContainer>
  )
}

export default withComponentLabel(Register, 'Register')